import { render, staticRenderFns } from "./SwitchWidget.vue?vue&type=template&id=5aaf8255&scoped=true&"
import script from "./SwitchWidget.vue?vue&type=script&lang=js&"
export * from "./SwitchWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaf8255",
  null
  
)

export default component.exports